import './spinStretch.css'
export function SpinStretch (){
    return(
        <div class="spinS"></div>
    )
}